import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwooshComponent } from 'src/app/common/ui-elements/swoosh.component';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { AppService } from '../../../app.service';
import { ContentService } from '../../../services/content.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-teaminsights-communication',
  templateUrl: './team-teaminsights-communication.component.html',
  styleUrls: ['./team-teaminsights-communication.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
   imports: [SafeHtmlPipe, SwooshComponent, CommonModule],
})
export class TeamInsightsCommunicationComponent implements OnInit {
  swooshText = '';
  swooshRoute = '/team';
  swooshFragment = 'TeamInsights';
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(
    private appService: AppService,
    private contentService: ContentService,
  ) {}

  ngOnInit() {
    let teamInfo = this.appService.getTeamInfo();
    let yourMbtiType = this.appService.mbtiType;
    let additionalFilters = teamInfo.teamCommunicationStyles;

    this.contentService.getReport('TeamCommunicationStyles', yourMbtiType, additionalFilters).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
